import React from 'react';
import { PiletApi } from '@sharefiledev/sharefile-appshell';

export interface AppContext {
	piletApi: PiletApi;
	originAnalyticsTrackingId?: string;
}

const AppContext = React.createContext<AppContext>({
	piletApi: {} as any,
	originAnalyticsTrackingId: '',
});

export interface AppContextProviderProps {
	piletApi: PiletApi;
	originAnalyticsTrackingId?: string;
	children: React.ReactNode;
}
export const AppContextProvider: React.FC<AppContextProviderProps> = ({
	piletApi,
	originAnalyticsTrackingId,
	children,
}) => (
	<AppContext.Provider value={{ piletApi, originAnalyticsTrackingId }}>
		{children}
	</AppContext.Provider>
);

export const useAppContext = () => React.useContext(AppContext);
